var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M663 382L663 410",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 663.5,
    cy: 377.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M658.987 377.19C658.987 373.283 662.288 370.117 666.358 370.117C666.943 370.117 667.511 370.184 668.056 370.308C666.742 369.48 665.187 369 663.519 369C658.814 369 655 372.806 655 377.5C655 382.194 658.814 386 663.519 386C665.814 386 667.895 385.093 669.427 383.62C668.492 384.032 667.454 384.263 666.358 384.263C662.288 384.263 658.987 381.096 658.987 377.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M672.402 376.6L672.37 374.146L670.535 375.719L668.304 375.056L669.112 377.337L667.765 379.381L670.1 379.218L671.499 381.144L672.133 378.763L674.345 377.909L672.402 376.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch3);
export default __webpack_public_path__ + "static/media/church_3.d922f40cb5e9114b73f62c6790417faa.svg";
export { ForwardRef as ReactComponent };